import { FC, ReactElement } from "react";
import { Box, Card, CircularProgress, Stack, styled } from "@mui/material";

import { DynamicTable } from "@/components";
import CardHeading from "../card-heading";
import { columns } from "@/columns/COMMON/potential-countries";

export const StyledBox = styled(Box)({
  flex: 1,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  "& .MuiTable-root": {
    borderCollapse: "collapse",
    minWidth: "initial",

    "& .MuiTableCell-root": {
      border: 0,
    },

    "& .MuiTableBody-root .MuiTableCell-root": {
      padding: "7px 12px !important",
      borderBlock: "1px solid #E6E7E7",
    },

    "& .MuiTableFooter-root .MuiTableCell-root": {
      background: "#CEDBDB",
      fontSize: "18px",
      fontWeight: 500,
      color: "#116B6F",
    },
  },
});

const CountriesCard: FC<{ isLoading: boolean; data: PotentialCountry[] }> = ({
  isLoading,
  data,
}): ReactElement => {
  return (
    <Card
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        maxHeight: 432,
      }}
    >
      <Box p={3}>
        <CardHeading text="Agreement Opportunities by Country" />
      </Box>

      {isLoading ? (
        <Stack minHeight={310} justifyContent="center" alignItems="center">
          <CircularProgress />
        </Stack>
      ) : (
        <StyledBox>
          <DynamicTable
            contentIdKey="program"
            columns={columns}
            data={data}
            isLoading={false}
            limit={10}
            page={1}
            total={10}
            stickyHeader
            hidePagination
            hideScrollBars
            isFullHeight
            square
            borderLess
            containerStyles={{
              overflow: "hidden",
            }}
          />
        </StyledBox>
      )}
    </Card>
  );
};

export default CountriesCard;
